<template>
  <div class="filter-container">
    <b-form-input
      v-if="inputType === 'text' || inputType === 'number'"
      :id="$attrs.id"
      v-model="filterValue"
      size="sm"
      :class="`table-filter ${inputType === 'number' && 'number-offset'}`"
      :placeholder="placeholder"
      :debounce="500"
      :type="inputType"
      @update="updateValue"
    />
    <b-form-select
      v-if="inputType === 'select'"
      :id="$attrs.id"
      v-model="filterValue"
      :options="filterOptions"
      size="sm"
      class="square-select"
      @change="updateValue"
    />
    <span
      class="filter-clear"
      @click="resetValue"
    ><BIconX /></span>
  </div>
</template>

<script>
import { BIconX } from 'bootstrap-vue';

export default {
  name: 'TableFilter',
  components: {BIconX},
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    inputType: {
      type: String,
      default: 'text'
    },
    filterOptions: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      filterValue: null
    };
  },
  watch: {
    value: function (value) {
      this.filterValue = value;
    }
  },
  mounted() {
    this.filterValue = this.value;
  },
  methods: {
    resetValue() {
      this.filterValue = null;
      this.$emit('input', this.filterValue);
    },
    updateValue() {
      this.$emit('input', this.filterValue);
    }
  }
};
</script>

<style scoped lang="scss">
  * {
    font-size: 0.875rem;
    line-height: 1.5;
  }

  .filter-container {
    position: relative;

    .filter-clear {
      position: absolute;
      right: 5px;
      top: 5px;
      cursor: pointer;
    }
  }

  .number-offset{
    padding-right: 20px;
  }

  .custom-select {
    background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 1.5rem center/8px 10px;
  }
</style>
